import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { filter, take } from 'rxjs';
import { Ask } from 'src/app/shareModule/models/ask.model';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { User } from 'src/app/shareModule/models/user.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadCommunityAsk } from 'src/app/shareModule/states/community-ask';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ask',
  templateUrl: './ask.component.html',
  styleUrls: ['./ask.component.scss']
})
export class AskComponent implements OnInit {

  @Input() title: boolean = true;
  @Input() gridNumber: string = '';
  @Input() grid: boolean = true;
  @Input() viewMode: boolean = false;
  @Input() categoryName: string = '';
  @Input() subCategoryName: string = '';
  @Input() onlyMemberAsk: Boolean = false;

  @ViewChild('askPopup') askPopup: Element;

  public addedCategoryList: Array<any> = [];
  public selectedSubCategoryName = '';
  public selectedCategoryId = null;
  public categoriesList: Array<any> = [];
  public selectedCategoryName = null;
  public selectedCategoryNameForDD = '';
  public commonModelRef: any = null;
  public askMsg: string = '';
  public askList: Array<any> = [];
  public ask: any = {
    memberShopAskLikes: []
  }
  public appUserId: any = 0
  public isLogin: any = 0
  public imgUrl = environment.ImageUrl;
  public addedSubCategoryList: Array<any> = [];

  constructor(private store: Store<AppState>,private modalService: NgbModal, private auth: AuthServiceService, private toastr: ToastrService, private local: LocalServiceService, private customerService: CustomerService) { }

  ngOnInit(): void {
    this._getCategoryList();
    const getUser = this.local.getUser();

    if (getUser) {
      this.appUserId = getUser.id;
    }

    (getUser) ? this.isLogin = 1 : 0;
    this.getAskList();
  }

  public onCategoryChange(catId, subCatName): void {
    this.selectedCategoryId = catId
    this.categoryName = this.selectedCategoryNameForDD = subCatName;
    // this.subCategoryName = this.selectedSubCategoryName = '';
    this._getSubCategoryList(subCatName);
  }

  public onRegionClick(name) {
    this.subCategoryName = this.selectedSubCategoryName = name;
  }

  private _getSubCategoryList(selectedSubCategoryName = '') {
    let selectedCategoryId = this._getSelectedCategoryId(); // Need update
    
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: selectedCategoryId,
      })
      .subscribe((response: any) => {
        response.body.map(e => {
          e.keyName = e.name
        });
        this.addedSubCategoryList = response.body;
        if (this.addedSubCategoryList.length > 0) {
          // this.selectedSubCategoryName = selectedSubCategoryName ? selectedSubCategoryName : "north|yishun";
          this.getProfileCharacterDetails()
          // this._getProductList();
        } else {
          this.selectedSubCategoryName = '';
        }
      });
  }

  private _getCategoryList() {
    this.auth.getAllMemberCategorieRelationship().subscribe((response: any) => {
      response.body.map(e => {
        e.keyName = e.name;
        e.sub = e.subCategory.map(i => ({
          keyName: i.categoryName,
          ...i
        }));
      });
      this.categoriesList = response.body;

      this.auth.getAllMemberShopCategory().subscribe((response: any) => {

        // this.categoriesList = response.body;
        this.addedCategoryList = response.body;
        if (this.addedCategoryList.length > 0) {
          this.categoryName = this.selectedCategoryName = this.addedCategoryList[0].name;
          this.selectedCategoryNameForDD = this.addedCategoryList[0].name;
          this._getSubCategoryList();
        } else {
          this.selectedCategoryName = this.categoriesList[0].name;
          this.selectedCategoryNameForDD = this.categoriesList[0].name;
        }
      });
      // this._getSubCategoryList();
    });
  }


  public getProfileCharacterDetails() {
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user), take(1)).subscribe((resp: User) => {
      if (resp?.region) {
        
        this.subCategoryName = this.selectedSubCategoryName = this.regionSplit(resp?.regionName) ?? "north|yishun";
        // this.addedCategoryList.push({
        //   keyName: this.subCategoryName,
        // })
      }
    });
  }

  private _getSelectedCategoryId(): any {
    return (
      this.addedCategoryList.filter(
        (i: any) => i.name == this.selectedCategoryName
      )[0]?.id || 0
    );
  }
  openAddPopup() {

    if (this.askList.length >= 1) {
      this.toastr.error("Only One Question can be added!");
      return true;
    }

    this.commonModelRef = this.modalService.open(this.askPopup, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "suggestion",
    });

  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  public submitAsk() {

     if (!this.categoryName || !this.subCategoryName || !this.askMsg) {
      this.toastr.error("Select CategoryName , SubCategoryName & Ask");
      return true;
    }
    this.auth.addMemberShopAsk({ message: this.askMsg, category: this.categoryName, subCategory: this.subCategoryName }).subscribe((resp: ApiResponse) => {
      this.askMsg = '';
      this.commonModelRef.close();
      this.toastr.success(resp.message);
      this.getAskList();
      this.store.dispatch(loadCommunityAsk());
    });
  }

  public getAskList() {
    (this.onlyMemberAsk ? this.auth.getMemberAsk() : this.auth.getAllMemberShopAsk()).subscribe((resp: ApiResponse) => {
      this.askList = resp.body;
      this.askList.map((row: any) => {
        row.createdAt = this.local.timeAgo(row.createdAt / 1000)
        row.profileImage = this.local.checkImageProfile(row.appUser)
      })
    });
  }

  public deleteAsk(id) {
    this.local.alertConfirm({
      message: 'Are you sure you want to delete this ask?'
    }).then((res) => {
      if (res.isConfirmed) {
        this.auth.deleteMemberShopAsk(id).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.getAskList();
        });
      }
    });
  }

  public hideAsk(id) {
    this.local.alertConfirm({
      message: 'Are you sure you want to hide this ask?'
    }).then((res) => {
      if (res.isConfirmed) {
        this.customerService.hideMemberShopAsk(id).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this.getAskList();
        });
      }
    });
  }

  public viewAsk(modal, message, item?: any) {
    this.askMsg = message;
    this.commonModelRef = this.modalService.open(modal, {
      size: "md",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "ask_detail_modal",
    });
    this.ask = item
  }

  hasCheckedForum(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0
  }

  likeForum(askId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !")
    }
    const payload = {
      userId: this.appUserId,
      askId: askId,
    }

    if (this.hasCheckedForum(data.memberShopAskLikes))
      data.memberShopAskLikes = data.memberShopAskLikes.filter((row: any) => row.userId != this.appUserId)
    else
      data.memberShopAskLikes = [...data.memberShopAskLikes, payload]

    this.auth.likeMemberShopAsk(payload).subscribe()
  }
}
